module.exports = __webpack_public_path__ + "img/sell.cd7c8928.svg";